export default __webpack_public_path__ + "static/media/win.37dbbf52.wav";